import React, { useEffect, useState } from 'react'
import SpecteraFormStep from './SpecteraFormStep'
import SpecteraClaimFormOverview from '../SpecteraClaimFormOverview'
import { connect, useDispatch } from 'react-redux'
import ScrollToTarget from '../../../../../../../../../itrust_common/components/others/ScrollToTarget'
import { reduxForm } from 'redux-form'
import { visionInsuranceClaimFormEdit, visionInsuranceClaimFormUpdate } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import Alert from '../../../../../../../../../itrust_common/components/Alert'
import RpaClaimSubmitButton from '../../../../claimForm/submitClaim/RpaClaimSubmitButton'
import ClaimFormSync from '../../../../../../../../../components/authorised/order/edit/ClaimFormSync'
import DateFormatView from '../../../../../../../../../itrust_common/components/others/DateFormatView'
import { DIRECT_SAVE_CLAIM_OPTIONS, isDirectSaveClaimOrg } from '../../../../claimForm/directSaveClaimOrgHelper'
import { withOrdersInsuranceId } from '../../../../../../../../../components/authorised/order/claimFormDropdownUtils'
import _ from 'lodash'

function SpecteraClaimForm(props) {
  const { handleSubmit, editing, visionInsuranceClaimForm, organisation, order, visionInsuranceConfig, claimFormTemplate } = props
  const dispatch = useDispatch()
  const isDirectSaveOrg = isDirectSaveClaimOrg(organisation?.subdomain, order?.store_id)
  const firstStepActionLabel = isDirectSaveOrg ? 'Save' : 'Next'
  const [selectedLocation, setSelectedLocation] = useState(
    visionInsuranceClaimForm?.location || DIRECT_SAVE_CLAIM_OPTIONS[0].value
  )
  let filters = {}

  useEffect(() => {
    if (visionInsuranceClaimForm?.location) {
      setSelectedLocation(visionInsuranceClaimForm.location)
    }
  }, [visionInsuranceClaimForm?.location])

  useEffect(() => {
    if (isDirectSaveOrg) {
      dispatch(visionInsuranceClaimFormEdit({ formView: 'form' }))
      return
    }

    if (visionInsuranceClaimForm.claim_data?.charges?.length) {
      dispatch(visionInsuranceClaimFormEdit({ formView: 'overview' }))
    } else {
      dispatch(visionInsuranceClaimFormEdit({ formView: 'form' }))
    }
  }, [visionInsuranceClaimForm.claim_data?.charges, isDirectSaveOrg])

  const hasMaterialsBenefit = (formData) => {
    const eligibilityData = (formData ?? visionInsuranceClaimForm)?.eligibility?.data || []
    return eligibilityData.some(item =>
      ['Frame Benefit', 'Lens Benefit', 'Contacts Benefit'].includes(item.service_type) && item.active
    )
  }

  const getNextStep = (res) => {
    const activeModule = editing.activeModule || 'first'
    if (isDirectSaveOrg && activeModule === 'first') return

    res = res ?? visionInsuranceClaimForm
    switch (activeModule) {
      case 'first':
        dispatch(visionInsuranceClaimFormEdit({ activeModule: 'second' }));
        break;
      case 'second':
        if (res.exams?.exam?.is_cpt2_selected === 'no' || !hasMaterialsBenefit(res)) {
          dispatch(visionInsuranceClaimFormEdit({ activeModule: '', formView: 'overview' }))
        } else {
          dispatch(visionInsuranceClaimFormEdit({ activeModule: 'final' }));
        }
        break;
      case 'final':
        dispatch(visionInsuranceClaimFormEdit({ activeModule: '', formView: 'overview' }))
        break;
      default:
        break;
    }
  };

  const resolveLensNames = (lensObj) => {
    if (!lensObj || typeof lensObj !== 'object') return lensObj
    const formatted = { ...lensObj }
    const lensesConfig =
      props.specteraVisionInsurance?.lenses_configurations ||
      props.specteraVisionInsurance?.os?.lenses_configurations ||
      []
    const safeConfig = Array.isArray(lensesConfig)
      ? lensesConfig
      : (lensesConfig?.lenses_configurations || [])

    const optionsConfig =
      props.specteraVisionInsurance?.lens_options_configurations ??
      props.specteraVisionInsurance?.os?.lens_options_configurations ??
      []
    const optionsList = Array.isArray(optionsConfig)
      ? optionsConfig
      : (optionsConfig?.LensOptionsList ?? optionsConfig?.lens_options_configurations?.LensOptionsList ?? [])

    const fields = [
      'lens_type',
      'lens_style',
      'material',
      'lens_material',
      'treatment',
      'lens_treatment',
      'options_1',
      'options_2',
      'options_3',
      'options_4',
      'options_5'
    ]
    fields.forEach((field) => {
      if (formatted[field] && typeof formatted[field] === 'object') {
        formatted[field] =
          formatted[field].label ||
          formatted[field].DESCRIPTION ||
          formatted[field].LENS_STYLE_DESCRIPTION ||
          formatted[field].LENS_MATERIAL_DESCRIPTION ||
          formatted[field].LENS_TREATMENT_DESCRIPTION ||
          formatted[field].LENS_OPTION_DESCRIPTION ||
          formatted[field].value
      }
    })

    // If lens_style is numeric ID
    const styleVal = formatted.lens_style
    if (typeof styleVal === 'number' || (!isNaN(Number(styleVal)) && styleVal !== '' && styleVal !== null)) {
      for (const config of safeConfig) {
        const styles = config?.LensStyleList || (config?.LENS_STYLE_ID ? [config] : [])
        const matched = styles.find(s => String(s.LENS_STYLE_ID) === String(styleVal))
        if (matched?.LENS_STYLE_DESCRIPTION) {
          formatted.lens_style = matched.LENS_STYLE_DESCRIPTION
          break
        }
      }
    }

    // If material is numeric ID
    const matVal = formatted.material ?? formatted.lens_material
    if (typeof matVal === 'number' || (!isNaN(Number(matVal)) && matVal !== '' && matVal !== null)) {
      for (const config of safeConfig) {
        const styles = config?.LensStyleList || (config?.LENS_STYLE_ID ? [config] : [])
        for (const style of styles) {
          const matchedMat = style?.LensMaterialList?.find(m => String(m.LENS_MATERIAL_ID) === String(matVal))
          if (matchedMat?.LENS_MATERIAL_DESCRIPTION) {
            if ('material' in formatted) formatted.material = matchedMat.LENS_MATERIAL_DESCRIPTION
            if ('lens_material' in formatted) formatted.lens_material = matchedMat.LENS_MATERIAL_DESCRIPTION
            break
          }
        }
      }
    }

    // If treatment is numeric ID
    const treatVal = formatted.treatment ?? formatted.lens_treatment
    if (typeof treatVal === 'number' || (!isNaN(Number(treatVal)) && treatVal !== '' && treatVal !== null)) {
      for (const config of safeConfig) {
        const styles = config?.LensStyleList || (config?.LENS_STYLE_ID ? [config] : [])
        for (const style of styles) {
          for (const mat of (style?.LensMaterialList || [])) {
            const matchedTreat = mat?.LensTreatmentList?.find(t => String(t.LENS_TREATMENT_ID) === String(treatVal))
            if (matchedTreat?.LENS_TREATMENT_DESCRIPTION) {
              if ('treatment' in formatted) formatted.treatment = matchedTreat.LENS_TREATMENT_DESCRIPTION
              if ('lens_treatment' in formatted) formatted.lens_treatment = matchedTreat.LENS_TREATMENT_DESCRIPTION
              break
            }
          }
        }
      }
    }

    // If options_1 .. 5 are numeric IDs
    for (let i = 1; i <= 5; i++) {
      const optKey = `options_${i}`
      const optVal = formatted[optKey]
      if (typeof optVal === 'number' || (!isNaN(Number(optVal)) && optVal !== '' && optVal !== null)) {
        const matchedOpt = optionsList.find(o =>
          String(o.LENS_OPTION_ID) === String(optVal) ||
          String(o.OPTION_ID) === String(optVal) ||
          String(o.ID) === String(optVal) ||
          String(o.id) === String(optVal)
        )
        if (matchedOpt) {
          const desc = matchedOpt.LENS_OPTION_DESCRIPTION || matchedOpt.OPTION_DESCRIPTION || matchedOpt.DESCRIPTION || matchedOpt.name
          if (desc) formatted[optKey] = desc
        }
      }
    }

    return formatted
  }

  const computeData = (data) => {
    const filterActive = (items) => Array.isArray(items) ? items.filter(item => item.active) : items;
    const { exams } = data;
    if (exams) {
      exams.exam && Object.keys(exams.exam).forEach(field => {
        if (exams.exam[field]) {
          exams.exam[field] = filterActive(exams.exam[field]);
        }
      });
      exams.impression && Object.keys(exams.impression).forEach(field => {
        if (exams.impression[field]) {
          exams.impression[field]['selected_value'] = filterActive(exams.impression[field]['selected_value']);
          exams.impression[field]['cpt_codes'] = filterActive(exams.impression[field]['cpt_codes']);
        }
      });
    }
    else {
      return { ...data, exams: { exam: {}, impression: {} }, contact_lens_fit_and_follow_up: {} }
    }

    if (data.lab_lenses) {
      data.lab_lenses = resolveLensNames(data.lab_lenses)
    }
    if (data.lens) {
      data.lens = resolveLensNames(data.lens)
    }

    return data;
  };

  const validateFormData = (data) => {
    const isAnyModuleSelected = data.eligibility?.data.find(item => item.active)
    let chargesValidateArr = data.claim_data?.charges?.map(item => Number(item.charge))
    const hasNaN = chargesValidateArr ? (chargesValidateArr.find(item => Number.isNaN(item)) !== undefined) : false
    if (!isAnyModuleSelected) {
      Alert.warning('Please select a service to proceed.')
      return false
    }
    if (hasNaN) {
      Alert.warning('Invalid Amount')
      return false
    }

    const activeModule = editing.activeModule || 'first'
    if (activeModule === 'final') {
      const isLensBenefitSelected = data.eligibility?.data?.find(
        (item) => item.service_type === 'Lens Benefit'
      )?.active
      if (isLensBenefitSelected) {
        const option1 = data.lab_lenses?.options_1 || data.lens?.options_1
        const hasValue = (val) => {
          if (val === undefined || val === null || val === '') return false
          if (typeof val === 'object') return Object.keys(val).length > 0
          return true
        }
        if (!hasValue(option1)) {
          Alert.warning('Lens Option 1 is required.')
          return false
        }
      }
    }

    return true
  }

  const getFilters = (data) => {
    const activeModule = editing.activeModule || 'first'
    switch (activeModule) {
      case 'first':
        return { claim_sections: ['eligibility'] }
      case 'second':
        if (data?.exams?.exam?.is_cpt2_selected === 'no' || !hasMaterialsBenefit(data)) {
          return { claim_sections: ['exams', 'charges', 'services'] }
        }
        return { claim_sections: ['exams'] }
      case 'final':
        return { claim_sections: ['impression', 'services'] }
      default:
        return {}
    }
  }

  const handleClaimFormUpdate = async (data) => {
    data = computeData(data)
    const isFormValid = validateFormData(data)
    if (!_.isEmpty(data?.lab_frame) && !data.eligibility?.data?.find(item => item.service_type === 'Frame Benefit')?.active) {
      data = { ...data, lab_lenses_only: true }
    }
    filters = getFilters(data)
    if (isFormValid) {
      const payload = isDirectSaveOrg ? { ...data, location: selectedLocation } : data
      let res = await dispatch(visionInsuranceClaimFormUpdate(
        payload,
        withOrdersInsuranceId(filters, editing.orders_insurance_id),
      ))
      res = res.value.data.insurance_claim_form
      getNextStep(res)
      filters = {}
    }
    return
  }

  const handleSyncSuccessfully = () => {
    dispatch(visionInsuranceClaimFormEdit({ activeModule: 'first', formView: 'form' }));
  }

  const orderInsurance = order.orders_insurances_attributes?.find(
    (item) => item.id === editing?.orders_insurance_id,
  )
  const claimSubmissionAt = orderInsurance?.claim_submission_at || order.claim_submission_at

  return (
    <div className='mx-10 px-6'>
      <div className='d-flex justify-content-between align-items-center'>
        <div>
          {visionInsuranceConfig?.visible && orderInsurance?.vision_insurance_claim_exist && <RpaClaimSubmitButton order={order} />}
          {!isDirectSaveOrg && editing.formView !== 'overview' &&
            <button className='btn btn-outline-primary' onClick={() => dispatch(visionInsuranceClaimFormEdit({ formView: 'overview' }))}>Overview</button>
          }
          {claimSubmissionAt && (
            <span className='text-danger ml-6'>
              Previous Claim Send on <DateFormatView dateTime={claimSubmissionAt} />
            </span>
          )}
        </div>
        <div className='d-flex align-items-center'>
          {isDirectSaveOrg ? (
            <div className="form-group mb-0 ml-md-5">
              <label className="mb-1" htmlFor="direct-save-claim-location">Location:</label>
              <select
                id="direct-save-claim-location"
                className="form-control"
                style={{ minWidth: '180px' }}
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
              >
                {DIRECT_SAVE_CLAIM_OPTIONS.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <ClaimFormSync label="Reset" handleAfterSyncSuccessfully={handleSyncSuccessfully} />
          )}
        </div>
      </div>
      {!isDirectSaveOrg && editing.formView === 'overview' ? (
        <SpecteraClaimFormOverview
          visionInsuranceClaimForm={visionInsuranceClaimForm}
          claimFormTemplate={claimFormTemplate}
        />
      ) : (
        <form onSubmit={handleSubmit(handleClaimFormUpdate)}>
          <SpecteraFormStep pprops={{ ...props, firstStepActionLabel }} />
        </form>
      )}
    </div>
  )
}

SpecteraClaimForm = reduxForm({
  form: 'SpecteraClaimForm',
  enableReinitialize: true,
  shouldValidate: () => true,
  onSubmitFail: () => ScrollToTarget()
})(SpecteraClaimForm)

const mapStateToProps = (state) => {
  const { organisation: { organisation }, order: { order }, visionInsuranceClaimForm: { visionInsuranceClaimForm, saving, editing }, specteraVisionInsurance } = state

  return {
    specteraVisionInsurance,
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    organisation,
    order,
    visionInsuranceClaimForm,
    editing,
    saving,
    initialValues: {
      ...visionInsuranceClaimForm,
    }
  }
}

export default connect(mapStateToProps)(SpecteraClaimForm)
